export default class FuPaCompanyMetaData {
  public static readonly JobPageLink = 'https://www.fupa.net/news/stellenboerse-jobs-bei-fupa-3067062';
}
